import { UploadFileToS3 } from 'domain/usecases/surgical-order/upload-file-to-s3'
import { S3UploadClient } from 'service/protocols/s3-upload/s3-upload-client'

export class RemoteUploadFileToS3 implements UploadFileToS3 {
  constructor(private readonly s3UploadClient: S3UploadClient) {}

  upload(params: UploadFileToS3.Params): Promise<void> {
    return this.s3UploadClient.upload(params)
  }
}
